import template from './springDataTable.html';
import controller from './springDataTable.controller';

let SpringDataTableComponent = {
  restrict: 'E',
  bindings: {
    restUrl: '@',
    columns: '=',
    selectable: '=',
    selectFunction: '=',
    filter: '=',
    filterrefresh: '=',
    tabledata: '=?',
    recordSize: '@',
    defaultSort: '@',
    rowClassFunction: '=?',
    totalCount: '=?',
    showTotals: '=?',
    /** Optional map of column.value -> number to use for totals instead of summing the current page. */
    serverColumnTotals: '=?',
    /** When set (e.g. "page"), table rows and pagination come from response[key] instead of the root Spring Page JSON. */
    nestedPageKey: '@',
    /** Called after each successful GET with full response body ({ page, statistics }, etc.). */
    onTableResponse: '&'
  },
  template,
  controller
};

export default SpringDataTableComponent;



// WEBPACK FOOTER //
// ./client/common/springDataTable/springDataTable.component.js